import { useEffect, useRef } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getBets } from '../api';
import { useAuth } from '../auth';
import { fireConfetti } from './Confetti';
import { haptic } from '../haptic';
import { toast } from '../toast';

export default function BetWinWatcher() {
  const { user } = useAuth();
  const { data } = useQuery({ queryKey: ['bets'], queryFn: getBets, enabled: !!user, refetchInterval: 30_000 });
  const seenIds = useRef<Set<string>>(new Set());
  const seeded = useRef(false);

  useEffect(() => {
    if (!user || !data?.bets) return;
    const settled = data.bets.filter((b) => b.status === 'settled' && b.winner);
    if (!seeded.current) {
      // First load: don't fire on history.
      for (const b of settled) seenIds.current.add(b.id);
      seeded.current = true;
      return;
    }
    for (const b of settled) {
      if (seenIds.current.has(b.id)) continue;
      seenIds.current.add(b.id);
      const youWon = (b.proposer === user && b.winner === 'proposer') || (b.opponent === user && b.winner === 'opponent');
      if (youWon) {
        fireConfetti(28);
        haptic.success();
        const other = b.proposer === user ? b.opponent : b.proposer;
        toast.success(`You won €${b.stake} from ${other}.`);
      }
    }
  }, [data, user]);

  return null;
}
